__turbopack_context__.v({
  "className": "esklarheitkurrent_3db3d513-module__ioxxtW__className",
  "variable": "esklarheitkurrent_3db3d513-module__ioxxtW__variable",
});
